import * as types from "../types/failedPrints"

const initialState = []

const failedPrintsReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.ADD_FAILED_PRINT:
      return [...state, action.failedPrint]
    case types.REMOVE_FAILED_PRINTS:
      return state.filter((failedPrint) =>
        !action.printRequestIds.some(printRequestId =>
          printRequestId === failedPrint.printRequestId
        )
      )
    case types.REMOVE_ALL_FAILED_PRINTS:
      return []
    default:
      return state
  }
}

export default failedPrintsReducer